
import React, { useEffect, useState } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import {
  filterVisibleFoods,
  getFoodImageUrl,
  normalizeCategory
} from "../utils/foodAvailability"

const API = "https://food-backend-9733.onrender.com"

const categories = [
  {
    id: "cookies",
    name: "Cookies",
    image: "/categories/cookies.jpg"
  },
  {
    id: "snacks",
    name: "Snacks",
    image: "/categories/snacks.jpg"
  },
  {
    id: "desserts",
    name: "Desserts",
    image: "/categories/desserts.jpg"
  },
  {
    id: "mixtures",
    name: "Mixtures",
    image: "/categories/mixtures.jpg"
  }
]

const Food = () => {
  const [foods, setFoods] = useState([])
  const [slideIndex, setSlideIndex] = useState(0)

  const navigate = useNavigate()

  useEffect(() => {
    axios.get(`${API}/foods`)
      .then((res) => {
        setFoods(filterVisibleFoods(res.data))
      })
      .catch((err) => {
        console.log("Load foods error:", err)
      })
  }, [])

  const sliderFoods = foods.filter(
    (item) => normalizeCategory(item.category) === "cookies"
  )

  useEffect(() => {
    setSlideIndex(0)
  }, [sliderFoods.length])

  useEffect(() => {
    if (sliderFoods.length <= 1) return

    const timer = setInterval(() => {
      setSlideIndex((prev) =>
        prev >= sliderFoods.length - 1 ? 0 : prev + 1
      )
    }, 3000)

    return () => clearInterval(timer)
  }, [sliderFoods.length])

  const activeSlide =
    sliderFoods.length > 0
      ? sliderFoods[slideIndex % sliderFoods.length]
      : null

  const countByCategory = (category) =>
    foods.filter(
      (item) => normalizeCategory(item.category) === category
    ).length

  const fortyEightCount = countByCategory("48hours")
  const weeklyCount = countByCategory("weekly")

  return (
    <div className="food-page">

      {activeSlide && (
        <div
          className="hero-slider"
          onClick={() => navigate("/category/cookies")}
          role="link"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate("/category/cookies")
            }
          }}
        >
          <img
            src={getFoodImageUrl(activeSlide, API)}
            alt={activeSlide.name || "Fresh Cookies"}
            onError={(e) => {
              e.currentTarget.onerror = null
              e.currentTarget.src = "/logo192.png"
            }}
          />

          <div className="hero-bottom-title">
            <span>Fresh Cookies</span>
            <h1>{activeSlide.name}</h1>
            <p>Made to order with limited daily availability.</p>
          </div>

          <div className="slider-dots">
            {sliderFoods.map((item, index) => (
              <span
                key={item.id ?? `${item.name}-${index}`}
                onClick={(e) => {
                  e.stopPropagation()
                  setSlideIndex(index)
                }}
                className={
                  slideIndex === index
                    ? "dot active-dot"
                    : "dot"
                }
              />
            ))}
          </div>
        </div>
      )}

      <div className="home-value-strip">
        <div>
          <b>Fresh batches</b>
          <span>Prepared after confirmation</span>
        </div>

        <div>
          <b>Limited stock</b>
          <span>Live item availability</span>
        </div>

        <div>
          <b>Order tracking</b>
          <span>Updates from placed to delivered</span>
        </div>
      </div>

      <div className="special-section-heading">
        <h2>48 Hours Food Items</h2>
        <p>
          These items are freshly uploaded on YouTube.
          Order within 48 hours before availability ends.
        </p>
      </div>

      <div className="special-banner-section">
        <div
          className="special-banner-card"
          onClick={() => navigate("/48-hours")}
        >
          <img src="/48hours.jpg" alt="48 Hours" />

          <div className="special-banner-overlay">
            <h2>48 Hours Items</h2>
            <p>
              {fortyEightCount} limited specials available now
            </p>
          </div>
        </div>
      </div>

      <div className="special-section-heading">
        <h2>Weekly Food Items</h2>
        <p>
          These snacks and homemade specials
          are available for one full week after
          uploading on YouTube.
        </p>
      </div>

      <div className="special-banner-section">
        <div
          className="special-banner-card"
          onClick={() => navigate("/weekly")}
        >
          <img src="/weekly.jpg" alt="Weekly Items" />

          <div className="special-banner-overlay">
            <h2>Weekly Items</h2>
            <p>
              {weeklyCount} weekly homemade foods available now
            </p>
          </div>
        </div>
      </div>

      <div className="category-main-heading">
        <h2>Explore Our Homemade Categories</h2>
        <p>
          Freshly prepared cookies, snacks, desserts
          and mixtures made with love.
        </p>
      </div>

      <div className="category-small-grid">
        {categories.map((cat) => (
          <div
            key={cat.id}
            className="category-small-card"
            onClick={() => navigate(`/category/${cat.id}`)}
          >
            <img
              src={cat.image}
              alt={cat.name}
              onError={(e) => {
                e.currentTarget.onerror = null
                e.currentTarget.src = "/logo192.png"
              }}
            />

            <h3>{cat.name}</h3>
          </div>
        ))}
      </div>

      <footer className="main-footer">
        <h2>Srilekha Vantillu</h2>

        <p className="footer-intro">
          Premium homemade snacks and sweets prepared in small batches
          for families who prefer fresh, clean and traditional food.
        </p>

        <div className="footer-grid">
          <div>
            <h3>Quick Links</h3>

            <button
              type="button"
              className="footer-link"
              onClick={() => navigate("/48-hours")}
            >
              48 Hours Specials
            </button>

            <button
              type="button"
              className="footer-link"
              onClick={() => navigate("/weekly")}
            >
              Weekly Items
            </button>

            <button
              type="button"
              className="footer-link"
              onClick={() => navigate("/category/cookies")}
            >
              Cookies
            </button>

            <button
              type="button"
              className="footer-link"
              onClick={() => navigate("/category/snacks")}
            >
              Snacks
            </button>

            <button
              type="button"
              className="footer-link"
              onClick={() => navigate("/category/desserts")}
            >
              Desserts
            </button>

            <button
              type="button"
              className="footer-link"
              onClick={() => navigate("/category/mixtures")}
            >
              Mixtures
            </button>
          </div>

          <div>
            <h3>Contact Details</h3>
            <p>Phone: Update from admin profile</p>
            <p>Email: support@srilekhavantillu.com</p>
            <p>Delivery: Based on customer location</p>
          </div>

          <div>
            <h3>Customer Care</h3>
            <p>Order status notifications</p>
            <p>Custom requirements accepted</p>
            <p>Fresh stock and expiry visibility</p>
          </div>
        </div>

        <p className="copyright">
          © Srilekha Vantillu. All rights reserved.
        </p>
      </footer>

    </div>
  )
}

export default Food
